import React from 'react';

const KnowledgeGraph = () => {
  return (
    <div className="bg-white rounded-lg shadow mb-6 p-4">
      <h2 className="text-lg font-medium text-gray-800 mb-3">Knowledge Graph</h2>
      <div className="h-40 flex items-center justify-center">
        <div className="flex items-center">
          <div className="h-16 w-16 rounded-full bg-red-400 flex items-center justify-center text-white mr-3"></div>
          <div className="h-16 w-16 rounded-full bg-green-400 flex items-center justify-center text-white mr-3"></div>
          <div className="h-16 w-16 rounded-full bg-yellow-400 flex items-center justify-center text-white mr-3"></div>
          <div className="h-16 w-16 rounded-full bg-purple-400 flex items-center justify-center text-white"></div>
        </div>
      </div>
      <p className="text-sm text-gray-500 text-center italic">Visual snapshot of relevant knowledge items</p>
    </div>
  );
};

export default KnowledgeGraph;